import { getApi } from './common/apis';

export default class LegacyRfpService {
    async getLegacyRfpDetails({ vendorId, rfpId }) {
        if (!vendorId) {
            throw new Error('vendorId is required to fetch legacy RFP details.');
        }
        if (!rfpId) {
            throw new Error('rfpId is required to fetch legacy RFP details.');
        }

        const encodedVendorId = encodeURIComponent(vendorId);
        const encodedRfpId = encodeURIComponent(rfpId);

        return getApi(`v1/vendor-response-screen/by-ids/${encodedRfpId}/${encodedVendorId}`);
    }
}

